import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import LazyImage from '../LazyImage/LazyImage';
import styles from './ProjectCard.module.css';

/**
 * ProjectCard — reusable card used on the /projects listing,
 * the "More Projects" section of a detail page, and anywhere
 * else a project needs to be represented compactly.
 *
 * Props
 * ─────
 * project  {object}   A project entry from src/data/projects.js
 * size     {'normal'|'small'}  normal = full listing card, small = related card
 * animate  {boolean}  wrap in framer-motion whileInView (default true)
 * delay    {number}   stagger delay in seconds (default 0)
 */
export default function ProjectCard({
                                        project,
                                        size = 'normal',
                                        animate = true,
                                        delay = 0,
                                    }) {
    const card = (
        <Link
            to={`/projects/${project.id}`}
            className={[styles.card, size === 'small' ? styles.cardSmall : ''].filter(Boolean).join(' ')}
        >
            <div className={styles.imgWrap}>
                <LazyImage
                    src={project.image}
                    alt={project.title}
                    className={styles.img}
                />
            </div>

            <div className={styles.body}>
                <div className={styles.bodyMain}>
                    <p className={styles.title}>{project.title} - {project.client}</p>
                    <p className={styles.meta}>
                        {project.year},&nbsp;{project.location}
                    </p>
                </div>
                <span className={styles.arrow} aria-hidden="true">
                         <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="18"></g>
                             <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                                 <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                </span>

            </div>
        </Link>
    );

    if (!animate) return card;

    return (
        <motion.div
            initial={{opacity: 0, y: 28}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true, amount: 0.15}}
            transition={{duration: 0.5, ease: 'easeOut', delay}}
        >
            {card}
        </motion.div>
    );
}
